module.exports = __webpack_public_path__ + "img/xu1-2.fd6bd247.png";